export const addPrefixToken = (tokenId) => `algorand/asa/${tokenId}`;
export const extractTokenId = (tokenId) => {
    return tokenId.split("/")[2];
};
//# sourceMappingURL=tokens.js.map